import {
  FLOW_SELECTION_FETCHING,
  FLOW_SELECTION_PAGINATION,
  FLOW_SELECTION_SEARCH,
  FLOW_SELECTION_SUCCESS,
} from "./actionType";

const initialState = {
  modelDeviceList: [],
  //   modelSearch: {},
  tempSearch: { 
    START_DATE: new Date(),
    END_DATE: new Date(),
  },
  pagination:{sizePerPage:10,page:1}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FLOW_SELECTION_FETCHING:
      return { ...state, modelDeviceList: [] };
    case FLOW_SELECTION_SUCCESS:
      return { ...state, modelDeviceList: action.payload };
    case FLOW_SELECTION_SEARCH:
      return {
        ...state,
        // modelSearch: {
        //   LOAD_DATE: moment(action.payload.START_DATE).format("YYYY-MM-DD"),
        //   LOAD_TO_DATE: moment(action.payload.END_DATE).format("YYYY-MM-DD") ,
        // },
        tempSearch: action.payload,
      };
    case FLOW_SELECTION_PAGINATION:
      return { ...state, sizePerPage: action.payload.sizePerPage ,page:action.payload.page };
    default:
      return state;
  }
};
